import { Box } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

import OrderFilterSection from "../OrderFilterSection";

export interface OrderListFilterProps {
  handleChangeFilter?: (filterObj: any) => void;
  message: JSX.Element | string;
  listOrder: any[];
  loading?: boolean;
  setIsSearched?: (status: boolean) => void;
}

const useStyles = makeStyles(
  () => ({
    root: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      width: "100%"
    },
    wrapper: {
      display: "flex",
      justifyContent: "space-between"
    }
  }),
  { name: "OrderListFilter" }
);

const OrderListFilter: React.FC<OrderListFilterProps> = props => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.wrapper}>
        <Box className={classes.root}>
          <OrderFilterSection {...props} />
        </Box>
      </div>
    </>
  );
};

export default OrderListFilter;
